// Neutral placeholder content, no invented persons, partners, or specific numbers.
// Real data to be provided by NANDA SÁ team.
import { l } from "@/i18n/helpers";

export const TESTIMONIALS = [];

export const PARTNERS = [];

export const IMPACT_STATS = [
 { value: 4, suffix: "", label: l("Maisons", "Houses", "Casas") },
 { value: 10, suffix: "", label: l("Trésors valorisés", "Treasures celebrated", "Tesouros valorizados") },
 { value: 8, suffix: "", label: l("Secteurs d'activité", "Sectors of activity", "Sectores de actividade") },
 { value: 2023, suffix: "", label: l("Année de fondation", "Year of foundation", "Ano de fundação") },
 { value: 3, suffix: "", label: l("Langues officielles", "Official languages", "Línguas oficiais") },
];

export const ACTUALITES = [
 {
 slug: "lancement-cosmetiques",
 date: "2026-01-20",
 type: l("Lancement", "Launch", "Lançamento"),
 title: l(
 "Lancement de la première collection NANDA SÁ Cosmétiques",
 "Launch of the first NANDA SÁ Cosmétiques collection",
 "Lançamento da primeira colecção NANDA SÁ Cosmétiques"
 ),
 excerpt: l(
 "Une gamme de soins essentiels autour de quatre plantes emblématiques d'Afrique de l'Ouest.",
 "A range of essential skincare built around four emblematic West African plants.",
 "Uma gama de cuidados essenciais em torno de quatro plantas emblemáticas da África Ocidental."
 ),
 cover:
 "https://customer-assets.emergentagent.com/job_nanda-sa-hub/artifacts/plyjek6o_47CBEAFE-FCD9-4575-8F76-84ADCAD9C1C5.png",
 },
 {
 slug: "arrivee-nanda-sa",
 date: "2026-01-08",
 type: l("Nouveauté", "New arrival", "Novidade"),
 title: l(
 "NANDA SÁ. Fleur de Sel d'Adéane & Miel de Mangrove",
 "NANDA SÁ. Adéane Fleur de Sel & Mangrove Honey",
 "NANDA SÁ. Flor de Sal de Adéane & Mel de Mangue"
 ),
 excerpt: l(
 "Deux signatures emblématiques de Guinée-Bissau rejoignent notre catalogue.",
 "Two emblematic signatures from Guinée-Bissau join our catalogue.",
 "Duas assinaturas emblemáticas da Guiné-Bissau juntam-se ao nosso catálogo."
 ),
 cover:
 "https://customer-assets.emergentagent.com/job_nanda-sa-hub/artifacts/2angpgo2_13D726A8-9E58-45A4-8626-BC13E18E5FD0.jpeg",
 },
 {
 slug: "huile-palme-cacheu",
 date: "2025-12-15",
 type: l("Nouveauté", "New arrival", "Novidade"),
 title: l(
 "Huile de Palme Rouge artisanale de Cacheu",
 "Artisanal Red Palm Oil from Cacheu",
 "Óleo de Palma Vermelho artesanal de Cacheu"
 ),
 excerpt: l(
 "Une extraction traditionnelle en Guinée-Bissau, désormais disponible.",
 "A traditional extraction from Guinea-Bissau, now available.",
 "Uma extracção tradicional da Guiné-Bissau, agora disponível."
 ),
 cover:
 "https://customer-assets.emergentagent.com/job_nanda-sa-hub/artifacts/8h1p67p9_C0B99994-90F8-4411-BA8F-1F45E4CF549B.png",
 },
];
